import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-slate-800 via-slate-900 to-slate-800 text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* About */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-700 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-xl">م.م</span>
              </div>
              <div className="flex flex-col">
                <h3 className="font-bold text-lg leading-tight">الأستاذ مصطفى محمد</h3>
                <span className="text-xs text-gray-400">خدمات مؤسسية احترافية</span>
              </div>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed mb-6">
              {t('footerAbout')}
            </p>
            <div className="flex gap-3">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-blue-600 rounded-lg transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-blue-400 rounded-lg transition-colors cursor-pointer">
                <i className="ri-twitter-x-fill text-lg"></i>
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-blue-700 rounded-lg transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-pink-600 rounded-lg transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-lg mb-6">{t('quickLinks')}</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-300 hover:text-blue-400 text-sm transition-colors cursor-pointer">
                  {t('home')}
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-blue-400 text-sm transition-colors cursor-pointer">
                  {t('about')}
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 hover:text-blue-400 text-sm transition-colors cursor-pointer">
                  {t('services')}
                </Link>
              </li>
              <li>
                <Link to="/portfolio" className="text-gray-300 hover:text-blue-400 text-sm transition-colors cursor-pointer">
                  {t('portfolio')}
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-300 hover:text-blue-400 text-sm transition-colors cursor-pointer">
                  {t('blog')}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-blue-400 text-sm transition-colors cursor-pointer">
                  {t('contact')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-bold text-lg mb-6">{t('servicesTitle')}</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/services/consulting" className="text-gray-300 hover:text-blue-400 text-sm transition-colors cursor-pointer">
                  {t('service1')}
                </Link>
              </li>
              <li>
                <Link to="/services/planning" className="text-gray-300 hover:text-blue-400 text-sm transition-colors cursor-pointer">
                  {t('service2')}
                </Link>
              </li>
              <li>
                <Link to="/services/management" className="text-gray-300 hover:text-blue-400 text-sm transition-colors cursor-pointer">
                  {t('service3')}
                </Link>
              </li>
              <li>
                <Link to="/services/development" className="text-gray-300 hover:text-blue-400 text-sm transition-colors cursor-pointer">
                  {t('service4')}
                </Link>
              </li>
              <li>
                <Link to="/services/training" className="text-gray-300 hover:text-blue-400 text-sm transition-colors cursor-pointer">
                  {t('service5')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-bold text-lg mb-6">{t('contactTitle')}</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-lg flex-shrink-0">
                  <i className="ri-map-pin-line text-blue-400"></i>
                </div>
                <div>
                  <p className="text-gray-300 text-sm">المملكة العربية السعودية</p>
                  <p className="text-gray-400 text-xs mt-1">الرياض</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-lg flex-shrink-0">
                  <i className="ri-phone-line text-blue-400"></i>
                </div>
                <div>
                  <a href="tel:+966500000000" className="text-gray-300 text-sm hover:text-blue-400 transition-colors cursor-pointer">
                    +966 50 000 0000
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-lg flex-shrink-0">
                  <i className="ri-mail-line text-blue-400"></i>
                </div>
                <div>
                  <a href="mailto:info@mustafa-mohammed.com" className="text-gray-300 text-sm hover:text-blue-400 transition-colors cursor-pointer">
                    info@mustafa-mohammed.com
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-gray-400">
            <p>
              © {currentYear} الأستاذ مصطفى محمد. {t('allRightsReserved')}
            </p>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-blue-400 transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}